import { readApiError } from "_shared/_errors/api-error";

const refreshedTraceOperations = new Set<string>();
let refreshedUntracedErrors = new WeakSet<object>();

/**
 * Refreshes authorized state at most once for a visible conflict. This never retries the write;
 * the owning workflow decides what the user does after seeing the fresh projection.
 */
export async function refreshStaleStateOnce(
  error: unknown,
  operation: string,
  refresh: (freshState: unknown) => void | Promise<void>,
): Promise<boolean> {
  const result = readApiError(error);
  if (result.status !== 409 && result.status !== 412) return false;

  if (result.traceId) {
    const key = `${result.traceId}:${operation}`;
    if (refreshedTraceOperations.has(key)) return false;
    refreshedTraceOperations.add(key);
  } else if (typeof error === "object" && error !== null) {
    if (refreshedUntracedErrors.has(error)) return false;
    refreshedUntracedErrors.add(error);
  } else {
    return false;
  }

  await refresh(result.freshState);
  return true;
}

export function resetStaleStateRefreshes(): void {
  refreshedTraceOperations.clear();
  refreshedUntracedErrors = new WeakSet<object>();
}
